export const LOCALIZATOR_INIT: string = 'LOCALIZATOR INITIALIZED';
export const EVENTS_HORIZON_INIT: string = 'EVENTS HORIZON INITIALIZED';
export const TOOLS_INIT: string = 'TOOLS INITIALIZED';
export const APP_USER_STATE_TEMPLATES_INIT: string = 'APP USER STATE TEMPLATES INITIALIZED';
export const MEDIATION_INIT: string = 'MEDIATION INITIALIZED';
export const KEYCLOAK_INIT: string = 'KEYCLOAK INITIALIZED';
export const BE_VERSION_VERIFIED: string = 'BE VERSION VERIFIED';
